import { ThemePrepared, themes } from '@fluentui/react-northstar';
import { ThemeNames } from '@smb/fabric-teams-theme';

export function getThemeNameGivenStardustTheme(
  theme: ThemePrepared
): ThemeNames {
  switch (theme.siteVariables.bodyBackground.toLowerCase()) {
    case themes.teamsDark.siteVariables.bodyBackground.toLowerCase():
      return ThemeNames.dark;
    case themes.teamsHighContrast.siteVariables.bodyBackground.toLowerCase():
      return ThemeNames.contrast;
    default:
      return ThemeNames.default;
  }
}
